import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-charcoal text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/12306700e4421a2fbf2cd7195169e5c5/1b92c1ad0443bec4782d9915e7e1208c.png" 
              alt="LaCrue Digital Agency" 
              className="h-40 mb-4 brightness-0 invert"
            />
            <p className="font-inter text-sm text-gray-400 leading-relaxed">
              Premium websites and local SEO for businesses that want more customers.
            </p>
          </div>

          <div>
            <h4 className="font-inter font-semibold text-base mb-4">Pages</h4>
            <ul className="space-y-4">
              <li>
                <Link
                  to="/"
                  className="font-inter text-[15px] text-white hover:text-primary-light transition-colors cursor-pointer"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="font-inter text-[15px] text-white hover:text-primary-light transition-colors cursor-pointer"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="font-inter text-[15px] text-white hover:text-primary-light transition-colors cursor-pointer"
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="font-inter text-[15px] text-white hover:text-primary-light transition-colors cursor-pointer"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="font-inter text-[15px] text-white hover:text-primary-light transition-colors cursor-pointer"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-inter font-semibold text-base mb-4">Connect</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="mailto:lacruedigitalagency@gmail.com"
                  className="font-inter text-[15px] text-white hover:text-primary-light transition-colors cursor-pointer"
                >
                  lacruedigitalagency@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+17204001546"
                  className="font-inter text-[15px] text-white hover:text-primary-light transition-colors cursor-pointer"
                >
                  (720) 400-1546
                </a>
              </li>
            </ul>
            <div className="flex items-center space-x-4 mt-6">
              <a
                href="https://instagram.com/lacruecole18"
                target="_blank"
                rel="noopener noreferrer"
                className="w-6 h-6 flex items-center justify-center text-white/50 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://facebook.com/lacruecole18"
                target="_blank"
                rel="noopener noreferrer"
                className="w-6 h-6 flex items-center justify-center text-white/50 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-facebook-line text-xl"></i>
              </a>
              <a
                href="https://twitter.com/lacruecole18"
                target="_blank"
                rel="noopener noreferrer"
                className="w-6 h-6 flex items-center justify-center text-white/50 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-6 text-center">
          <p className="font-inter text-[13px] text-gray-500">
            © {currentYear} LaCrue Digital Agency. All rights reserved. |{' '}
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-400 transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}